import { validateMoneyNumber, validateMobile, validateRegexn, validateInteger, validateAccount, validateIP, validateTel, validateFixedTel, validateZipCode, validIdCard } from './validate'

const Validate = {
  install: function (Vue) {
    /**
     * 注意:  定义type 规则时 不用做非空验证
     *        只需要传入 required:true 即可
     * */
    /**
     * 保留两位小数
     */
    const isValidMoney = (rule, value, callback) => {
      if (value) {
        if (!validateMoneyNumber(value)) {
          callback(new Error('请输入正确的数字，最多保留两位小数!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    /**
     * 验证手机号
     */
    const isValidMobile = (rule, value, callback) => {
      if (value) {
        if (!validateMobile(value)) {
          callback(new Error('您输入的手机号不正确!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    const isValidTel = (rule, value, callback) => {
      if (value) {
        if (!validateTel(value)) {
          callback(new Error('您输入的号码不正确!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    const isValidFixedTel = (rule, value, callback) => {
      if (value) {
        if (!validateFixedTel(value)) {
          callback(new Error('您输入的号码不正确!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    /**
     * 含有非法字符(只能输入字母、汉字)
     */
    const isValidRegexn = (rule, value, callback) => {
      if (value) {
        if (!validateRegexn(value)) {
          callback(new Error('含有非法字符(只能输入字母、汉字)!'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    /**
     * 请输入正整数
     */
    const isValidInteger = (rule, value, callback) => {
      if (value) {
        if (!validateInteger(value)) {
          callback(new Error('请输入正整数'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    /**
     * 请输入正整数
     */
    const isValidAccount = (rule, value, callback) => {
      if (value) {
        if (!validateAccount(value)) {
          callback(new Error('3~20个字符，可使用字母、数字、下划线，需以字母开头'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    /**
     * IP地址验证
     */
    const isValidIP = (rule, value, callback) => {
      if (value) {
        if (!validateIP(value)) {
          callback(new Error('请输入正确的IP地址'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    /**
     * 邮政编号验证
     */
    const isValidZipCode = (rule, value, callback) => {
      if (value) {
        if (!validateZipCode(value)) {
          callback(new Error('请输入正确的邮政编号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    /**
     * 身份证号码验证
     */
    const isValidIdCard = (rule, value, callback) => {
      if (value) {
        if (!validIdCard(value)) {
          callback(new Error('请输入正确的身份证号码'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }

    /**
     * 参数 item
     * required true  必填项
     * maxLength  字符串的最大长度
     * min 和 max 必须同时给 min < max  type=number
     * type 手机号 mobile
     *      邮箱   email
     *      网址   url
     *      各种自定义类型   定义在 src/utils/validate 中    持续添加中.......
     * */
    Vue.prototype.filter_rules = function (item) {
      const rules = []
      if (item.required) {
        rules.push({ required: true, message: '请输入' + item.name, trigger: 'blur' })
      }
      if (item.maxLength) {
        rules.push({ max: item.maxLength, message: '长度少于' + item.maxLength + '个字', trigger: 'blur' })
      }
      if (item.min && item.max) {
        rules.push({ min: item.min, max: item.max, message: '字符长度在' + item.min + '至' + item.max + '之间!', trigger: 'blur' })
      }
      if (item.type) {
        const type = item.type
        switch (type) {
          case 'email':
            rules.push({ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur,change' })
            break
          case 'money':
            rules.push({ validator: isValidMoney, trigger: 'blur,change' })
            break
          case 'mobile': // 手机号码
            rules.push({ validator: isValidMobile, trigger: 'blur,change' })
            break
          case 'tel': // 手机号码、固定电话
            rules.push({ validator: isValidTel, trigger: 'blur,change' })
            break
          case 'fixed': // 固定电话
            rules.push({ validator: isValidFixedTel, trigger: 'blur,change' })
            break
          case 'regexn':
            rules.push({ validator: isValidRegexn, trigger: 'blur,change' })
            break
          case 'integer':
            rules.push({ validator: isValidInteger, trigger: 'blur,change' })
            break
          case 'account':
            rules.push({ validator: isValidAccount, trigger: 'blur,change' })
            break
          case 'ip':
            rules.push({ validator: isValidIP, trigger: 'blur,change' })
            break
          case 'idCard':
            rules.push({ validator: isValidIdCard, trigger: 'blur,change' })
            break
          case 'zip':
            rules.push({ validator: isValidZipCode, trigger: 'blur,change' })
            break
          default:
            rules.push({})
            break
        }
      }

      return rules
    }
  }
}

export default Validate



// WEBPACK FOOTER //
// ./src/utils/filter_rules.js